/** The calls behind a customer's order gallery. */
import { api } from './client';
import type { ScansResponse } from '../types/roll';

export const gallery = {
  scans: (orderId: string) => api.get<ScansResponse>(`/api/v1/orders/${orderId}/scans`),
  /** The same payload for an admin previewing the customer's gallery. */
  previewScans: (orderId: string) => api.get<ScansResponse>(`/api/v1/admin/orders/${orderId}/preview-scans`),
  /** A presigned link to a roll's contact sheet PDF, generated on first request. */
  contactSheet: (orderId: string, rollId: string) =>
    api.get<{ url: string; filename?: string }>(`/api/v1/orders/${orderId}/rolls/${rollId}/contact-sheet`),
  deleteEdit: (orderId: string, scanId: string) => api.delete<void>(`/api/v1/edits/${orderId}/${scanId}`),
};
